/** @format */

import React, { useCallback } from "react";
import javascriptHandler from "../apis/javascriptHandler";
import { withVersionParams } from "../HOC/withVersionParams";
import UnderageAgrContent10601 from "../components/UnderageAgrPage/UnderageAgrContent10601";
import UnderageAgrContent10602 from "../components/UnderageAgrPage/UnderageAgrContent10602";
// import useLongPress from "../hooks/useLongPress";

interface Props {
   v: number;
}

const AgrUnderAge: React.FC = () => {
   const v = 10601;
   // const btnRef = useRef<HTMLButtonElement>();
   const [isIssuing, setIsIssuing] = React.useState<boolean>(false);
   const [checked, setChecked] = React.useState(false);
   const isTbed = process.env.REACT_APP_BUILD === "tbed";
   const _domain = isTbed
      ? "https://resource-test.zzeung.id/app/webn/v4/#"
      : "https://resource-stg.zzeung.kr/";

   const goTo = useCallback(
      (e: React.MouseEvent<HTMLElement>, link: string) => {
         e.preventDefault();
         javascriptHandler._callHandler("OpenWebView", _domain + link);
      },
      []
   );

   const goBack = useCallback(() => {
      javascriptHandler._callHandler("_showExitPopup", null);
   }, []);

   const onClick = useCallback(() => {
      if (isIssuing) return;
      setIsIssuing(true);
      javascriptHandler._callHandler("_onBtnClick", "1");
      setIsIssuing(false);
   }, [isIssuing]);

   // const longPress = useLongPress({
   //   onClick: () => {
   //     console.log("Short Btn Pressed")
   //     javascriptHandler._callHandler("_onBtnClick", "1")
   //   },
   //   onLongPress: () => {
   //     console.log("Long Btn Pressed")
   //     javascriptHandler._callHandler("_onBtnLongClick", "1")
   //   }, ms: 300
   // });

   // useEffect(() => {
   //   if (!isIssuing && checked) {
   //     btnRef.current?.addEventListener("touchstart", longPress.onTouchStart);
   //     btnRef.current?.addEventListener("touchend", longPress.onTouchEnd);
   //   }
   //   return () => {
   //     btnRef.current?.removeEventListener("touchstart", longPress.onTouchStart);
   //     btnRef.current?.removeEventListener("touchend", longPress.onTouchEnd);
   //   }
   // }, [isIssuing, checked]);

   return (
      <>
         {v <= 10601 ? (
            <UnderageAgrContent10601
               checked={checked}
               setChecked={setChecked}
               goTo={goTo}
               onClick={onClick}
            />
         ) : (
            <UnderageAgrContent10602
               checked={checked}
               setChecked={setChecked}
               goTo={goTo}
               goBack={goBack}
               onClick={onClick}
            />
         )}
      </>
   );
};

export default withVersionParams(AgrUnderAge);
